import Model, { attr } from '@ember-data/model';
import { AdvancedReportCriteria } from 'uplisting-frontend/transforms/advanced-report-criteria';
import type {
  OccasionType,
  TableSectionFields,
} from 'uplisting-frontend/models/occasion';

export enum OccasionFilterType {
  and = 'and',
  or = 'or',
  in = 'in',
  between = 'between',
  notIn = 'not_in',
  gt = 'gt',
  lt = 'lt',
}

export interface IOccasionFilter {
  field: TableSectionFields;
  type: OccasionFilterType;
  values: string[] | IOccasionFilter[] | boolean[];
}

export interface IOccasionFilterGroup {
  type: OccasionFilterType;

  values: OccasionFilterItemType[];
}

export type OccasionFilterItemType = IOccasionFilter | IOccasionFilterGroup;
export type OccasionFilters = OccasionFilterItemType[];

export interface IAdvancedReportConfigurationCriteriaFilter {
  occasion_type: OccasionType;
  occasion_filters: OccasionFilters;
}

export interface IAdvancedReportConfigurationCriteriaFields {
  occasions: string;
}

export interface IAdvancedReportConfigurationCriteria {
  filter: IAdvancedReportConfigurationCriteriaFilter;
  time_zone?: string;
  fields: IAdvancedReportConfigurationCriteriaFields;
  sort?: string;
}

export default class AdvancedReportConfigurationModel extends Model {
  @attr('string') name!: string;
  @attr('advanced-report-criteria') criteria!: AdvancedReportCriteria;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'advanced-report-configuration': AdvancedReportConfigurationModel;
  }
}
